"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Map_1 = __importDefault(require("./Map"));
var context_1 = __importDefault(require("./Map/context"));
var Marker_1 = __importDefault(require("./Marker"));
var context_2 = __importDefault(require("./Marker/context"));
var CustomOverlay_1 = __importDefault(require("./CustomOverlay"));
var context_3 = __importDefault(require("./CustomOverlay/context"));
var Circle_1 = __importDefault(require("./Circle"));
var context_4 = __importDefault(require("./Circle/context"));
var Rectangle_1 = __importDefault(require("./Rectangle"));
var context_5 = __importDefault(require("./Rectangle/context"));
var Ellipse_1 = __importDefault(require("./Ellipse"));
var context_6 = __importDefault(require("./Ellipse/context"));
var Polygon_1 = __importDefault(require("./Polygon"));
var context_7 = __importDefault(require("./Polygon/context"));
var Polyline_1 = __importDefault(require("./Polyline"));
var context_8 = __importDefault(require("./Polyline/context"));
var DrawingManager_1 = __importDefault(require("./DrawingManager"));
var context_9 = __importDefault(require("./DrawingManager/context"));
var KakaoMaps = {
    Map: Map_1.default,
    MapContext: context_1.default,
    Marker: Marker_1.default,
    MarkerContext: context_2.default,
    CustomOverlay: CustomOverlay_1.default,
    CustomOverlayContext: context_3.default,
    Circle: Circle_1.default,
    CircleContext: context_4.default,
    Rectangle: Rectangle_1.default,
    RectangleContext: context_5.default,
    Ellipse: Ellipse_1.default,
    EllipseContext: context_6.default,
    Polygon: Polygon_1.default,
    PolygonContext: context_7.default,
    Polyline: Polyline_1.default,
    PolylineContext: context_8.default,
    DrawingManager: DrawingManager_1.default,
    DrawingManagerContext: context_9.default,
};
module.exports = KakaoMaps;
